import * as React from 'react';
import { useIntl } from 'react-intl';

import { useTrackEventAmplitude } from '../../../core/Tracking/Amplitude/Amplitude';
import { InspirationLink } from '../../../design-system/components/inspiration-link/InspirationLink';
import { RATIO } from '../../../design-system/components/ratio/Ratio';
import { Destination } from '../../../resources/destination/domain/types/destination';
import { useUrlGenerator } from '../../../shared/hooks/useUrlGenerator';
import { PickDomain } from '../../../shared/utilities/types/PickDomain';
import { imageLoaderForId } from '../../Layout/Image/URL/ImageURL';

type DestinationSuitcaseInspirationLinkProps = {
    destination: PickDomain<Destination, 'id' | 'slug' | 'preposition' | 'name'>;
};

export function DestinationSuitcaseInspirationLink({
    destination,
}: DestinationSuitcaseInspirationLinkProps) {
    const { generatePath } = useUrlGenerator();
    const { formatMessage } = useIntl();
    const { trackEvent } = useTrackEventAmplitude();

    return (
        <InspirationLink
            href={generatePath('destination_suitcase', {
                destinationSlug: destination.slug,
            })}
            onClick={() => {
                trackEvent((ampli, defaultProperties) => {
                    ampli.destinationArticleClicked({
                        ...defaultProperties,
                        block: 'travel_guide_articles',
                        article_type: 'suitcase',
                        card_number: 0,
                        destination_id: destination.id,
                        destination_slug: destination.slug,
                    });
                });
            }}
            image={{
                alt: '',
                loader: imageLoaderForId({ aspectRatio: RATIO['16/9'] }),
                sizes: '(min-width: 1400px) 600px, (min-width: 992px) 500px, (min-width: 768px) 600px, (min-width: 576px) 500px, 100w',
                src: '1663715',
            }}
        >
            {formatMessage(
                { id: 'page.destinationSuitcase.page.title' },
                {
                    destinationPreposition: destination.preposition,
                    destinationName: destination.name,
                },
            )}
        </InspirationLink>
    );
}
